<template>
  <div>
    <knowledge-dialog
      ref="knowledgeDialog"
      :categories="categories"
      :availableTags="mapped_tags"
      @update-list="refreshKnowledgeEntries"
    />
    <insert-category
      ref="categoryDialog"
      @update-list="refreshKnowledgeEntries"
    ></insert-category>
    <knowledge-detail-dialog  ref="knowledgeDetailDialog"></knowledge-detail-dialog>

    <div class="biljeske-main-wrapper">
      <div class="biljeske-info-line">
        <div class="biljeske-info-line-left">
          <div class="biljeske-tags">
            
            <div
              class="biljeske-tag"
              :class="{ active: selectedTags.includes(single_tag) }"
              v-for="single_tag in mapped_tags"
              :key="single_tag"
              @click="toggleTag(single_tag)"
            >
              #{{ single_tag }}
            </div>
          </div>
        </div>
        <div class="biljeske-info-line-right">
          <div class="novi-dokument new-small-btn" @click="$refs.knowledgeDialog.open()">
         <span class="plus">+</span><span class="text-insert">{{ $t('components.knowledge_management.new_entry') }}</span> 
            
          </div>
          <div class="novi-dokument new-small-btn" @click="$refs.categoryDialog.open()">
         <span class="plus">+</span><span class="text-insert">{{ $t('components.knowledge_management.new_category') }}</span> 
            
          </div>
          
          
        </div>
      </div>
      <div class="biljeske-item-wrapper" v-if="categories.length > 0">
        <div
          class="biljeska-level1"
          v-for="(single_cat, index) in filteredCategories"
          :key="index"
        >
          <div class="biljeska biljeska-level1 biljeska-level-opened">
            <div class="biljeska-left">
              <div class="biljeska-no">{{ index + 1 }}</div>
              <div class="biljeska-title">{{ single_cat.name }}</div>
            </div>
            <div class="biljeska-right">
              <div class="edit-btn" @click="$refs.knowledgeDialog.open(null,single_cat.id)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                >
                  <g>
                    <g>
                      <path
                        fill="#0acab1"
                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="edit-btn" @click="$refs.categoryDialog.open(single_cat)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                >
                  <g>
                    <g>
                      <path
                        fill="#7b7b8a"
                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <div v-if="hasKnowledge(single_cat.id)" class="del-btn" @click="popDeleteScreenCategory(single_cat.id)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                >
                  <g>
                    <g>
                      <path
                        fill="#7b7b8a"
                        d="M11.934 3.295v.918a.459.459 0 0 1-.459.46H.46A.459.459 0 0 1 0 4.212v-.918c0-.634.514-1.147 1.148-1.147h2.524v-.46c0-.76.617-1.376 1.377-1.376h1.836c.76 0 1.377.616 1.377 1.377v.459h2.525c.633 0 1.147.513 1.147 1.147zM4.59 2.148h2.754v-.46a.46.46 0 0 0-.459-.458H5.05a.46.46 0 0 0-.459.459zm6.473 3.442c.082 0 .147.069.144.15l-.38 7.948A1.375 1.375 0 0 1 9.453 15h-6.97c-.736 0-1.34-.576-1.375-1.312l-.38-7.947a.143.143 0 0 1 .144-.15zm-3.26 7.115a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div>
            <div
              class="biljeska biljeska-level2"
              v-for="(single_know, key) in knowledgeEntries.filter(
                (entry) =>
                  entry.categoryId === single_cat.id &&
                  (selectedTags.length === 0 ||
                    entry.tags.some((tag) => selectedTags.includes(tag)))
              )"
              :key="key"
              @dblclick="$refs.knowledgeDialog.open(single_know,'')"
            >
              <div class="biljeska-left">
                <div class="biljeska-no">{{ index + 1 }}.{{ key + 1 }}</div>
                <div class="biljeska-title">{{ single_know.title }} </div>
                <div class="biljeske-tags" v-if="single_know.links.length > 0">
                  <div class="biljeska-tag-inside">
                    <span>{{ $t('components.knowledge_management.number_of_links', { count: single_know.links.length }) }}</span>
                  </div>
                </div>
                <div class="biljeske-tags">
                  <div
                    class="biljeska-tag-inside"
                    v-for="st in single_know.tags"
                    :key="st"
                  >
                    #{{ st }}
                  </div>
                </div>
              </div>
              <div class="biljeska-right">
                <div class="avatar-name-shorter">
                 {{returnInitials(single_know.updates[0].user_name)}}
                </div>
                <div class="review-btn" @click="showKnowledgeDetail(single_know, single_cat)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="14" viewBox="0 0 24 14"><g><g><path fill="#a2a4b0" d="M23.885 6.475a.942.942 0 0 1 0 1.125c-3.044 4.04-7.17 6.528-11.72 6.528-4.55 0-8.675-2.488-11.72-6.533a.942.942 0 0 1 0-1.125C3.49 2.43 7.615-.059 12.165-.059c4.55 0 8.676 2.488 11.72 6.534zm-6.722.886A5.01 5.01 0 0 0 11.84 2.04c-2.494.156-4.516 2.176-4.671 4.669a5.01 5.01 0 0 0 5.324 5.32c2.489-.16 4.51-2.18 4.671-4.668zm-4.822 2.361A2.692 2.692 0 0 1 9.476 6.86a2.708 2.708 0 0 1 2.519-2.517 2.692 2.692 0 0 1 2.864 2.862 2.708 2.708 0 0 1-2.518 2.517z"></path></g></g></svg>
                </div>
                <div class="edit-btn" @click="$refs.knowledgeDialog.open(single_know,'')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                >
                  <g>
                    <g>
                      <path
                        fill="#7b7b8a"
                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="del-btn" @click="popDeleteScreenKnowledge(single_know.id)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                >
                  <g>
                    <g>
                      <path
                        fill="#7b7b8a"
                        d="M11.934 3.295v.918a.459.459 0 0 1-.459.46H.46A.459.459 0 0 1 0 4.212v-.918c0-.634.514-1.147 1.148-1.147h2.524v-.46c0-.76.617-1.376 1.377-1.376h1.836c.76 0 1.377.616 1.377 1.377v.459h2.525c.633 0 1.147.513 1.147 1.147zM4.59 2.148h2.754v-.46a.46.46 0 0 0-.459-.458H5.05a.46.46 0 0 0-.459.459zm6.473 3.442c.082 0 .147.069.144.15l-.38 7.948A1.375 1.375 0 0 1 9.453 15h-6.97c-.736 0-1.34-.576-1.375-1.312l-.38-7.947a.143.143 0 0 1 .144-.15zm-3.26 7.115a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-knowledge">
        {{ $t('components.knowledge_management.empty_knowledge') }}
      </div>
    </div>
    <v-dialog v-model="delete_category_screen" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t('components.knowledge_management.delete_category_confirm') }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="delete_category_screen = false"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="removeCategory(selected_cat)"
          >
            {{ $t("page_2.page_2_3.delete_pop.btn_2") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_knowledge_screen" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t('components.knowledge_management.delete_knowledge_confirm') }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="delete_knowledge_screen = false"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="removeKnowledge(selected_know)"
          >
            {{ $t("page_2.page_2_3.delete_pop.btn_2") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {
  createCategory,
  getCategories,
  updateCategory,
  deleteCategory,
  createKnowledge,
  getKnowledge,
  updateKnowledge,
  deleteKnowledge,
  searchKnowledge,
} from "../../../../apiCallers/promise_handler_db/knowledgeManagement";
import InsertCategory from "../../../../components/knowledgeManagement/InsertCategory.vue";
import KnowledgeDetailDialog from '../../../../components/knowledgeManagement/KnowledgeDetailDialog.vue';
import KnowledgeDialog from "../../../../components/knowledgeManagement/KnowledgeDialog.vue";

export default {
  components: { KnowledgeDialog, InsertCategory, KnowledgeDetailDialog },
  // name: "KnowledgeComponent",
  data() {
    return {
      categories: [],
      selectedTags: [],
      knowledgeEntries: [],
      newCategoryName: "",
      delete_category_screen : false,
      delete_knowledge_screen : false,
      generalKnowledgeData: {
        id: null,
        categoryId: null,
        title: "",
        description: "",
        tags: [],
        removeFileIds: [],
        newFiles: [],
      },
      
      mapped_tags: [],
      availableTags: [],
      searchQuery: "",

      delete_category_screen : false,
      delete_knowledge_screen : false,

      selected_know : null,
      selected_cat : null,
      selectedKnowledge : null,
      selectedCategoryName : "",
      show_details_dialog : false
      
    };
  },
  computed: {
    filteredCategories() {
      if (this.selectedTags.length === 0) {
        return this.categories;
      }
      return this.categories.filter((category) =>
        this.knowledgeEntries.some(
          (entry) =>
            entry.categoryId === category.id &&
            entry.tags.some((tag) => this.selectedTags.includes(tag))
        )
      );
    },
  },
  methods: {
    hasKnowledge(single_id)
    {
      return !this.categories.filter(
                (entry) =>
                  entry.categoryId === single_id).length > 0
    },
    returnInitials(un)
    {
      console.log(un)
      if(un)
      {
         let arr = un.split(" ")
      let final = "";
      arr.forEach(p=> final += p[0])
      return final
      }else{
        return " "
      }
     
    },
    showKnowledgeDetail(entry, categoryName) {
      this.$refs.knowledgeDetailDialog.open(entry, categoryName)
    },
    popDeleteScreenCategory(selected){
      this.selected_cat = selected;
      this.delete_category_screen = true;
    },
    popDeleteScreenKnowledge(selected){
      this.selected_know = selected;
      this.delete_knowledge_screen = true;
    },
    async fetchCategories() {
      try {
        let resp = await getCategories();
        this.categories = resp.data;
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    },
    async knowledgeFromCategory(cat_id) {
      return this.knowledgeEntries.filter(
        (entry) => entry.categoryId === cat_id
      );
    },
    async addCategory() {
      try {
        await createCategory(this.newCategoryName);
        this.newCategoryName = "";
        this.fetchCategories();
      } catch (error) {
        console.error("Failed to add category:", error);
      }
    },
    async updateCategoryFunction(id, newName) {
      try {
        await updateCategory(id, newName);
        this.fetchCategories();
      } catch (error) {
        console.error("Failed to update category:", error);
      }
    },
    async removeCategory(id) {
      try {
        await deleteCategory(id);
        this.fetchCategories();
      } catch (error) {
        console.error("Failed to delete category:", error);
      }
      this.delete_category_screen = false;
    },
    async fetchKnowledge() {
      try {
        let resp = await getKnowledge();
        this.knowledgeEntries = resp.data;
        this.mapped_tags = [
          ...new Set(this.knowledgeEntries.flatMap((entry) => entry.tags)),
        ];
      } catch (error) {
        console.error("Failed to fetch knowledge entries:", error);
      }
    },
    async addKnowledge() {
      try {
        const { categoryId, title, tags, description, files } =
          this.generalKnowledgeData;
        await createKnowledge(categoryId, title, tags, description, files);
        this.fetchKnowledge();
        this.resetgeneralKnowledgeData();
      } catch (error) {
        console.error("Failed to add knowledge entry:", error);
      }
    },
    async updateKnowledgeEntry() {
      try {
        const {
          id,
          categoryId,
          title,
          tags,
          description,
          removeFileIds,
          newFiles,
        } = this.generalKnowledgeData;
        await updateKnowledge(
          id,
          categoryId,
          title,
          tags,
          description,
          removeFileIds,
          newFiles
        );
        this.fetchKnowledge();
      } catch (error) {
        console.error("Failed to update knowledge entry:", error);
      }
    },
    async removeKnowledge(id) {
      try {
        await deleteKnowledge(id);
        this.fetchKnowledge();
      } catch (error) {
        console.error("Failed to delete knowledge entry:", error);
      }
      this.delete_knowledge_screen = false;
    },
    async performSearch() {
      try {
        if (this.searchQuery.trim()) {
          this.knowledgeEntries = await searchKnowledge(this.searchQuery);
        } else {
          this.fetchKnowledge();
        }
      } catch (error) {
        console.error("Failed to perform search:", error);
      }
    },
    resetgeneralKnowledgeData() {
      this.generalKnowledgeData = {
        categoryId: null,
        title: "",
        description: "",
        tags: [],
        files: [],
      };
    },
    handleFilesUpload(event) {
      this.generalKnowledgeData.files = Array.from(event.target.files);
    },
    handleUpdateFilesUpload(event) {
      this.generalKnowledgeData.newFiles = Array.from(event.target.files);
    },
    async refreshKnowledgeEntries() {
      this.fetchCategories();
      this.fetchKnowledge();
    },
    toggleTag(tag) {
      const index = this.selectedTags.indexOf(tag);
      if (index === -1) {
        this.selectedTags.push(tag);
      } else {
        this.selectedTags.splice(index, 1);
      }
    },
  },
  mounted() {
    this.refreshKnowledgeEntries();
    this.$store.state.paginacija.title = this.$t("breadcrumbs.knowledge_mgmt");
  },
};
</script>

<style scoped></style>
